import { render, staticRenderFns } from "./VDocumentCard.vue?vue&type=template&id=5188f76d&scoped=true&lang=pug"
import script from "./VDocumentCard.vue?vue&type=script&lang=ts"
export * from "./VDocumentCard.vue?vue&type=script&lang=ts"
import style0 from "./VDocumentCard.vue?vue&type=style&index=0&id=5188f76d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5188f76d",
  null
  
)

export default component.exports